import { Component, HostListener } from '@angular/core';
import { ControlBase } from '../../base/control-base/control-base.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'page-footer-control',
    templateUrl: 'page-footer.control.html',
    styleUrl: './page-footer.control.scss',
    standalone: false,
})
export class PageFooterControl extends ControlBase {
    //TODO LATER: add extra behavior: fade in urls: link to games, link to more extensions, the original all rigths reserved should change
    constructor(protected override spinnerService: NgxSpinnerService) {
        super(spinnerService);

        this.developerCompanyUrl = this.settings.developerCompanyUrl;
        this.developerCompanyDomain = this.settings.developerCompanyDomain;
        if (this.innerSiteNavigation) {
            this.cookiePolicyUrl = '/cookiePolicy';
            this.privacyPolicyUrl = '/privacyPolicy';
        } else {
            this.cookiePolicyUrl = new URL('cookiePolicy', this.ioc.core.websiteConstants.applicationWebsite.FULL_MAIN_DOMAIN_URL).toString();
            this.privacyPolicyUrl = new URL('privacyPolicy', this.ioc.core.websiteConstants.applicationWebsite.FULL_MAIN_DOMAIN_URL).toString();
        }
    }

    public developerCompanyUrl: string;
    public developerCompanyDomain: string;
    public cookiePolicyUrl: string;
    public privacyPolicyUrl: string;

    //in websites this is true in extension this is false
    public innerSiteNavigation: boolean = true;

    public ngAfterViewChecked() {
        this.fixHeight();
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        this.fixHeight();
    }

    private fixHeight() {
        let $footer: JQuery<HTMLElement> = $('footer');
        let footerClientHeight: number = $footer[0].clientHeight;

        if (footerClientHeight < 57) {
            $footer.css('height', '57px');
            footerClientHeight = 57;
        }

        let $onlyHeaderDectionPage: JQuery<HTMLElement> = $('.only-header-section-page');
        if ($onlyHeaderDectionPage.length > 0) {
            let $container: JQuery<HTMLElement> = $onlyHeaderDectionPage.find('.container');
            if (!this.ioc.core.utils.isNullOrEmpty($container)) {
                let $header: JQuery<HTMLElement> = $onlyHeaderDectionPage.find('header');
                let headerPaddingTop: number = Number.parseInt($header.css('padding-top').replace('px', ''));
                let headerPaddingBottom: number = Number.parseInt($header.css('padding-bottom').replace('px', ''));

                let windowHeight: number = $(window).height();
                let containerMaxHeight: number = windowHeight - (footerClientHeight + headerPaddingTop + headerPaddingBottom);
                $container.css('height', containerMaxHeight);
                $onlyHeaderDectionPage.css('height', windowHeight - footerClientHeight);
            }
        }
    }
}
